import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Bugsnag from '@bugsnag/js';
import { getCookie, setCookie } from '../../utils/cookies';
import { readLanguagePreference } from '../../utils/languagePreference';

const languages = { en: 'en', vi: 'vi-VN', id: 'id-ID' };

// Mounted for the authenticated entry, independently of routes or screen size.
// Logout unmounts it; a different identity starts a fresh, guarded read.
export default function LanguageInitialization({ userId, countryCode }) {
  const { i18n } = useTranslation();
  useEffect(() => {
    if (!userId) return undefined;
    let active = true;
    const apply = (language) => {
      if (!active) return;
      i18n.changeLanguage(language);
    };
    const cookie = getCookie('mhub_profile_language_v1');
    apply(Object.values(languages).includes(cookie) ? cookie
      : ({ VN: 'vi-VN', ID: 'id-ID' }[(countryCode || '').toUpperCase()] || 'en'));
    readLanguagePreference().then((code) => {
      if (active && languages[code]) {
        apply(languages[code]);
        setCookie('mhub_profile_language_v1', languages[code], 365);
      }
    }).catch((error) => { if (!error.blocked) Bugsnag.notify(error); });
    return () => { active = false; };
    // Country changes and ordinary provider rerenders must preserve this tab.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);
  return null;
}

LanguageInitialization.propTypes = {
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  countryCode: PropTypes.string,
};
LanguageInitialization.defaultProps = { userId: null, countryCode: null };
